import React, { useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const Alerte = ({ alert }) => {
    const [showMessage, setShowMessage] = useState(false);
    const [color, setColor] = useState('rgba(211, 211, 211, 0.2)');

    const handleToggleMessage = () => {
        setShowMessage(!showMessage);
    };

    useEffect(()=>{
        switch (alert.level){
            case 3:
                setColor('rgba(255, 0, 0, 0.2)');
                break;
            case 2:
                setColor('rgba(255, 165, 0, 0.2)');
                break;
            case 1:
                setColor('rgba(20, 123, 255, 0.2)');
                break;
            default:
                setColor('rgba(211, 211, 211, 0.2)');
                break;
        }
    }, [alert])

    return (
        <Box
            sx={{
                backgroundColor: color,
                borderRadius: '8px',
                paddingBlock: 1, paddingInline: 2,
                display: 'flex',
                flexDirection:'column',
                maxWidth:'600px', minWidth: '300px',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h6">
                    {alert.title}
                </Typography>
                <IconButton onClick={handleToggleMessage}>
                    <InfoIcon />
                </IconButton>
                </Box>
            {showMessage && (
                <Typography variant="body2">
                    {alert.message}
                </Typography>
            )}
        </Box>
    );
};

export default Alerte;